export default __webpack_public_path__ + "static/media/Copper_Oct_Rank.74a1a5d4.png";